import * as types from "../constants";


export function ChangeLanguage(lang:types.LanguageOption): types.LanguageActionsTypes {  
  return {
    type: types.CHANGE_LANGUAGE,
    payload: lang
  };
}
